import type { CSSProperties, ComponentProps } from 'react';

import { cn } from '@crm/shared/lib';

type SkeletonProps = ComponentProps<'div'> & {
    width?: CSSProperties['width'];
    height?: CSSProperties['height'];
    border?: CSSProperties['borderRadius'];
};

const Skeleton = ({ className, width, height, border, style, ...props }: SkeletonProps) => (
    <div
        data-slot="skeleton"
        className={cn('animate-pulse overflow-hidden rounded-sm bg-[#ececef]', className)}
        style={{
            ...style,
            width: width ?? style?.width ?? '100%',
            height: height ?? style?.height ?? '100%',
            borderRadius: border ?? style?.borderRadius,
        }}
        {...props}
    />
);

export { Skeleton };
